Soho.slickCarousels = [];

Soho.slickCarousel = function() {
    // Site notice
    document.querySelectorAll('.js-carousel--site-notice').forEach(function(el, i) {
        if (el.classList.contains('slick-slider')) {
            return;
        }

        if (el.querySelectorAll('.notice__item').length <= 1) {
            return;
        }

        el.classList.add('js-carousel--site-notice-' + i);

        var carousel = new SlickCarousel({
            dots: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000
        }, 'site-notice-' + i);

        carousel.init($(el));

        Soho.slickCarousels.push(carousel);
    });
}
